import * as types from '../types.js';

export default {
	html: `
		<style>
			#product-packaging .pkg-hint { font-size: 0.78rem; color: #6b7280; margin: 0.15rem 0 0 0; line-height: 1.35; max-width: 42rem; }
			#product-packaging .pkg-check-row { display: flex; flex-wrap: wrap; align-items: center; gap: 1rem 1.25rem; margin-top: 0.35rem; }
			#product-packaging .pkg-check-row label { display: inline-flex; align-items: center; gap: 0.45rem; margin: 0; }
			#product-packaging .pkg-check-row input[type="checkbox"] { width: 1.05rem; height: 1.05rem; margin: 0; }
		</style>
		<form id="product-packaging" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="products"></datalist>
			<datalist id="manufacturers"></datalist>
			<div class="fsb">
				<label>Empresa<sup>*</sup><input id="company_id" type="text" list="companies" required></label>
				<label>ID<input id="id" type="text" disabled></label>
				<label>Produto<sup>*</sup><input id="product_id" type="text" list="products" required></label>
			</div>
			<div class="fsb">
				<label>Código<sup>*</sup><input id="code" type="text" placeholder="1X60" required></label>
				<label>Nível<sup>*</sup>
					<select id="level" required>
						<option value="S">Secundária</option>
						<option value="T">Terciária</option>
						<option value="P">Primária</option>
					</select>
				</label>
				<label>Fator<sup>*</sup><input id="factor" type="text" placeholder="60" required></label>
				<label>Cap. terciária<input id="tertiary_capacity" type="text" placeholder="100"></label>
			</div>
			<div class="fsb">
				<label title="Fabricante desta embalagem/GTIN — é o fabricante operacional do item quando esta embalagem é usada">Fabricante (GTIN)<input id="manufacturer_id" type="text" list="manufacturers" placeholder="Fabricante da embalagem"></label>
				<label>GTIN<input id="gtin" type="text" placeholder="EAN da embalagem"></label>
				<label title="Conteúdo ou identificador impresso no QR da etiqueta de embalagem">QR Code (etiqueta)
					<input id="qr_code" type="text" placeholder="Opcional — ver texto abaixo" autocomplete="off">
				</label>
			</div>
			<p class="pkg-hint"><strong>Fabricante (GTIN):</strong> o valor deste campo é o <strong>fabricante desta embalagem</strong> e prevalece em estoque, entradas, saídas e relatórios quando esta embalagem é usada. A grade de Embalagens mostra somente o fabricante gravado aqui. <strong>Sem embalagem cadastrada</strong> no fluxo operacional, o sistema usa o fabricante legado do cadastro de produto.</p>
			<p class="pkg-hint"><strong>GTIN:</strong> o cadastro de <strong>produto</strong> ainda pode ter GTIN e fabricante (modelo legado). Eles continuam válidos para tributação e integrações. Aqui você amarra o <strong>EAN desta embalagem (P/S/T)</strong> ao fabricante correto quando for diferente ou quando quiser rastreabilidade explícita. O <strong>mesmo EAN pode existir em embalagens de SKUs diferentes</strong> (ex.: caixa e fardo com o mesmo código de barras do fabricante). Duplicar GTIN entre produto e embalagem também é comum na migração. Na conferência por bip, se houver mais de uma embalagem com o mesmo GTIN, o sistema prioriza a marcada como <strong>padrão</strong> e, em empate, o menor ID.</p>
			<p class="pkg-hint"><strong>QR Code:</strong> campo opcional para guardar o <em>payload</em> que será codificado no QR da etiqueta de embalagem (ex.: código interno, GTIN+lote, JSON compacto — conforme layout acordado). Pode ser preenchido manualmente ou copiado do gerador/impressor de etiquetas; o SIAL armazena o valor para uso em relatórios, coletor ou futura geração automática de ZPL/PDF.</p>
			<div class="pkg-check-row">
				<label title="Embalagem padrão do produto para fatores/GTIN"><input id="is_default" type="checkbox"> Padrão</label>
				<label title="Cadastro inativo (não aparece em seleções)"><input id="is_disabled" type="checkbox"> Inativa</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,
	form: {
		selector: '#product-packaging',
		init(formset) {
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
		afterEditSetValues(formset) {
			const mfr = formset.form.getFieldBySelector('#manufacturer_id');
			const saved = mfr?.getValue?.();
			if (mfr && saved != null && saved !== '' && saved !== -1 && saved !== '-1')
				mfr.refresh();
		},
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#product_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#manufacturer_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('manufacturers', { labels: ['nick'] })] },
		{ properties: { selector: '#code' }, types: [types.name()] },
		{ properties: { selector: '#level' }, types: [] },
		{ properties: { selector: '#factor' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#tertiary_capacity' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#gtin' }, types: [types.gtin(), types.caps()] },
		{ properties: { selector: '#qr_code' }, types: [types.name()] },
		{ properties: { selector: '#is_default' }, types: [types.checkbox()] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]
};
